import React from "react";

// Custom SVG logo for Uberti Creative.
// All-vector, uses Cinzel (loaded globally) so it stays sharp at any size.

export function LogoFull({ className = "" }) {
  return (
    <svg
      viewBox="0 0 640 200"
      role="img"
      aria-label="Uberti Creative"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <linearGradient id="ucGold" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#f3dca0" />
          <stop offset="22%" stopColor="#e3c382" />
          <stop offset="55%" stopColor="#b08e48" />
          <stop offset="78%" stopColor="#8d6c2c" />
          <stop offset="100%" stopColor="#e8cd92" />
        </linearGradient>
        <linearGradient id="ucGoldThin" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#fbe9b8" />
          <stop offset="100%" stopColor="#a8843d" />
        </linearGradient>
        <filter id="ucShadow" x="-10%" y="-10%" width="120%" height="130%">
          <feDropShadow
            dx="0"
            dy="2"
            stdDeviation="1.6"
            floodColor="#000"
            floodOpacity="0.55"
          />
        </filter>
      </defs>

      {/* UC monogram — overlapped, slightly offset on the y-axis */}
      <g
        filter="url(#ucShadow)"
        fontFamily="Cinzel, 'Cormorant Garamond', serif"
        fontWeight={500}
        fill="url(#ucGold)"
      >
        <text x="0" y="130" fontSize="170" letterSpacing="-10">
          U
        </text>
        <text x="58" y="166" fontSize="170" letterSpacing="-10">
          C
        </text>
      </g>

      {/* Vertical separator */}
      <rect
        x="222"
        y="28"
        width="1.6"
        height="150"
        fill="url(#ucGoldThin)"
        opacity="0.95"
      />

      {/* UBERTI wordmark */}
      <text
        x="246"
        y="110"
        fontFamily="Cinzel, 'Cormorant Garamond', serif"
        fontWeight={500}
        fontSize="74"
        letterSpacing="10"
        fill="url(#ucGold)"
        filter="url(#ucShadow)"
      >
        UBERTI
      </text>

      {/* — CREATIVE — flourish */}
      <g
        fontFamily="Cinzel, serif"
        fontWeight={400}
        fill="url(#ucGold)"
      >
        <line
          x1="260"
          y1="155"
          x2="296"
          y2="155"
          stroke="url(#ucGoldThin)"
          strokeWidth="1.4"
        />
        <text
          x="306"
          y="162"
          fontSize="22"
          letterSpacing="9"
        >
          CREATIVE
        </text>
        <line
          x1="470"
          y1="155"
          x2="506"
          y2="155"
          stroke="url(#ucGoldThin)"
          strokeWidth="1.4"
        />
      </g>
    </svg>
  );
}

export const LogoMark = LogoFull;
